import React from "react";
import { DialogContent, Typography } from "@mui/material";
import { Icon } from "../../../components/icons";
import FactoryHours from "./FactoryHours";
import * as S from "./styles";

function DayScheduleModal({ open, onClose, selectedDate }) {
  return (
    <S.StyledDialogDaySchM
      open={open}
      onClose={onClose}
      maxWidth="lg"
      fullScreen
    >
      <S.StyledDialogTitleDaySchM>
        <Typography variant="h6" component="div">
          요일별 가동시간 설정
        </Typography>
        <S.CloseButtonDaySchM onClick={onClose} size="small">
          <Icon name="closeIcon" style={{ width: "20px", height: "20px" }} />
        </S.CloseButtonDaySchM>
      </S.StyledDialogTitleDaySchM>
      <DialogContent>
        <FactoryHours
          isModal={true}
          selectedDate={selectedDate}
          onClose={onClose}
        />
      </DialogContent>
    </S.StyledDialogDaySchM>
  );
}

export default DayScheduleModal;
